import { UserManager } from 'oidc-client-ts';
import oidcConfig from './oidcConfig';

// Shared with react-oidc-context so apiClient can renew tokens without the
// context's signinSilent wrapper (which swallows errors and sets isLoading).
export const userManager = new UserManager(oidcConfig);
